var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export var ResizeDetector = function (_Component) {
  _inherits(ResizeDetector, _Component);

  function ResizeDetector() {
    _classCallCheck(this, ResizeDetector);

    return _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).apply(this, arguments));
  }

  _createClass(ResizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!ResizeDetector.listener) {
        ResizeDetector.listener = function onWindowResize(event) {
          var width = window.innerWidth;
          var height = window.innerHeight;

          ResizeDetector.listeners.forEach(function (_ref) {
            var onResize = _ref.onResize,
                handleWidth = _ref.handleWidth,
                handleHeight = _ref.handleHeight;

            if (handleWidth && width !== ResizeDetector.windowSize.width || handleHeight && height !== ResizeDetector.windowSize.height) {
              onResize(event, { width: width, height: height });
            }
          });

          ResizeDetector.windowSize = {
            width: width,
            height: height
          };
        };

        window.addEventListener('resize', ResizeDetector.listener);

        ResizeDetector.listeners = [];

        ResizeDetector.windowSize = {
          width: window.innerWidth,
          height: window.innerHeight
        };
      }

      ResizeDetector.listeners.push({
        onResize: this.props.onResize,
        handleHeight: this.props.handleHeight,
        handleWidth: this.props.handleWidth
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      if (ResizeDetector.listeners) {
        ResizeDetector.listeners = ResizeDetector.listeners.filter(function (_ref2) {
          var onResize = _ref2.onResize;
          return onResize !== _this2.props.onResize;
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement('div', { style: { display: 'none' } });
    }
  }]);

  return ResizeDetector;
}(Component);

ResizeDetector.propTypes = {
  onResize: PropTypes.func.isRequired,
  handleWidth: PropTypes.bool,
  handleHeight: PropTypes.bool
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false
};